import {IntegrationTypeEnum} from "@app/enums/IntegrationTypeEnum";

export interface Integration<Config=Record<string, string | number>> {
  integrationUuid: string;
  isActive: boolean;
  isVisibleToTheUser: boolean;
  config: Config | null;
  type: string;
  integrationCategories: string[];
  extra?: any;
  /** The one market this portal publishes into, or null when it has none of its
   *  own and follows the dealer's own country (BRIEFD-7359). Backend-owned —
   *  `IntegrationEnum::PORTAL_MARKET`. Do not keep a copy of this table here. */
  marketCountry?: string | null;
  perBusinessUnit: boolean;
  wasRecentlyActivated?: boolean;
  firstAdEmailSentAt?: string | null;
}

export const IntegrationsEnum = IntegrationTypeEnum;

export interface Connections {
  connectionUuid?: string;
  dealershipName?: string;
  businessUnitUuid?: string;
  accessToken?: string;
}
